export const BASIC_TENANT_ID = 'basic'

export const REQUIRED_MSG = 'This field is required'
export const TENANT_MULTI_MSG = 'Select at least one tenant'

export const dropStyle = { marginTop: '5px', width: '100%' } as const

export const statusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'disabled' },
]

export const functionCallingOptions = [
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' },
]

export const TENANT_SCOPE_OPTIONS = [
  { label: 'All Tenant', value: 'basic' },
  { label: 'Tenant Specific', value: 'specific' },
]

export const dbToolOptions = [
  { label: 'PostgreSQL', value: 'postgres' },
  { label: 'MongoDB', value: 'mongodb' },
  { label: 'Pinecone', value: 'pinecone' },
  { label: 'MySQL', value: 'mysql' },
]
